import { render } from "./EnergyIndependence.vue?vue&type=template&id=34bb8fa1&scoped=true&ts=true"
import script from "./EnergyIndependence.vue?vue&type=script&lang=ts"
export * from "./EnergyIndependence.vue?vue&type=script&lang=ts"

import "./EnergyIndependence.vue?vue&type=style&index=0&id=34bb8fa1&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bb8fa1"]])

export default __exports__